import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Nav from './components/Nav';
import Intro from "./pages/Event_OldQuiz/Intro/Intro";
import Main from "./pages/Event_OldQuiz/Main/Main";
import Quiz from "./pages/Event_OldQuiz//Quiz/Quiz";
import Result from "./pages/Event_OldQuiz/Result/Result";
import Footer from "./components/Footer";
import InterView from "./pages/Event_InterView/Inerview";
const Router = () => {
  return (
    <BrowserRouter>
      {/* <Nav /> */}
      <Routes>
        <Route path="/eventOldQuiz/" element={<Intro />} />
        <Route path="/eventOldQuiz/main" element={<Main />} />
        <Route path="/eventOldQuiz/quiz" element={<Quiz />} />
        <Route path="/eventOldQuiz/result" element={<Result />} />
        <Route path="/event/10" element={<InterView />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
